// extracted by mini-css-extract-plugin
export default {"section":"styles_section__tP2wr","heading":"styles_heading__sL8cf","para":"styles_para__FGU2Y"};